import {
    CashFlowChart,
    ComparativoMensal,
    DateFilter,
    DistribuicaoDespesas,
    DistribuicaoReceitas,
    FluxoAcumulado,
    RecentTransactions,
    ResultadoMensal,
    SummaryCards,
    TopCategorias,
    TopReceitas,
} from '../../components/dashboard';
import { Header, Sidebar } from '../../components/layout';
import { useFinance, usePreferences } from '../../contexts';
import styles from './Graficos.module.css';

export function Graficos() {
    const { isLoading } = useFinance();
    const { t } = usePreferences();

    return (
        <div className={styles.layout}>
            <Sidebar />
            <main className={styles.main}>
                <Header title={t('nav.graficos')} />
                <div className={styles.content}>
                    <div className={styles.grid}>
                        <DateFilter />

                        {isLoading ? (
                            <div className={styles.loading}>{t('common.carregandoDados')}</div>
                        ) : (
                            <>
                                <section className={styles.summarySection}>
                                    <SummaryCards />
                                </section>

                                <div className={styles.fullRow}>
                                    <CashFlowChart />
                                </div>

                                <div className={styles.chartsGrid}>
                                    <ResultadoMensal />
                                    <ComparativoMensal />
                                </div>

                                <div className={styles.chartsGrid}>
                                    <DistribuicaoDespesas />
                                    <DistribuicaoReceitas />
                                </div>

                                <div className={styles.chartsGrid}>
                                    <TopCategorias />
                                    <TopReceitas />
                                </div>

                                <div className={styles.fullRow}>
                                    <FluxoAcumulado />
                                </div>

                                <div className={styles.fullRow}>
                                    <RecentTransactions />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}
